import { gql } from '@apollo/client';

export default gql`
  query getCollectiveitems($isRTL: Boolean) {
    getCollectiveitems(isRTL: $isRTL) {
      ok
      error
      data {
        _id
        branch
        autoNo
        docNo
        itemType
        barcode

        disabled
        additionId

        rentitemcost
        yeardepreciation
        rentdepreciation
        purchaseDate

        subitems

        name
        nameAr
        desc
        cost
        price
        unit
        photo

        categoryId
        categoryName
        categoryNameAr

        brandId
        brandName
        brandNameAr

        departmentId
        departmentName
        departmentNameAr
        departmentColor

        employeeId
        employeeName
        employeeNameAr
        employeeColor
        employeePhone

        resourseId
        resourseName
        resourseNameAr
        resourseColor

        userId

        createdAt
        updatedAt
      }
    }
  }
`;
